import type { FaireProductEntity } from "../../entity_types/product";

export const p_zawvgc9ngz: FaireProductEntity = {
  token: "p_zawvgc9ngz",
  type: "product",
  name: "Gold Plated Disc Mustard Seed Necklace",
  brandToken: "b_y2j497tv82",
  brandName: "The Pretty Jewellery",
  imageUrl: "https://cdn.faire.com/fastly/bc6c93285627b1bae11ffe193354fa8b156970450e326fa37a601709ce29933e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/be0020e67f92fbfdb67c9a466e91b2fb9f48ca63c959b702b7ac46f2274c097d.jpeg"
  ],
  priceDollars: 4.16,
  description: "Christian and Faith jewelry\n\nReal mustard seed\n\nGold Plated process\n\nStainless steel material\n\nPendant size 1.5CM\n\nNecklace length 45CM+5CM",
  tags: [],
  msrpDollars: 8.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:13.137Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
